module.exports = __webpack_public_path__ + "static/media/goa.c1e0289d.png";